import { render, staticRenderFns } from "./SelectorForm.vue?vue&type=template&id=284153c4&"
import script from "./SelectorForm.vue?vue&type=script&lang=js&"
export * from "./SelectorForm.vue?vue&type=script&lang=js&"
import style0 from "./SelectorForm.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports